export default [{
    name: 'fin-models',
    path: '/fin-models',
    component: () => import('./containers/final-models'),
},]